import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useState } from 'react';
import updateLabProcessStatus from '../../actions/admin/updateLabProcessStatus';
import type { Kit } from '../../hooks/useKits';
import { LabProcessStatus } from '../../hooks/useKits';

interface UpdateLabProcessStatusProps {
    open: boolean;
    onClose: () => void;
    kit: Kit;
    onLabProcessStatusUpdated: () => void;
}

const UpdateLabProcessStatusForm = ({
    open,
    onClose,
    kit,
    onLabProcessStatusUpdated,
}: UpdateLabProcessStatusProps) => {
    const [labProcessStatus, setLabProcessStatus] = useState<LabProcessStatus>(
        kit.LabProcessStatus
    );

    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();

        const target = e.target as typeof e.target & {
            labProcessStatus: { value: LabProcessStatus };
        };
        const labProcessStatus = target.labProcessStatus.value;

        updateLabProcessStatus({
            kitId: kit.KitId,
            labProcessStatus,
        });
        onLabProcessStatusUpdated();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <form onSubmit={handleSubmit}>
                <DialogTitle>Update lab process status</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Sample ID can be found on the sample collection tube
                    </DialogContentText>

                    <FormControl fullWidth margin="dense">
                        <InputLabel id="lab-process-status-select-label">
                            Lab process status
                        </InputLabel>
                        <Select
                            labelId="lab-process-status-select-label"
                            id="lab-process-status-select"
                            name="labProcessStatus"
                            label="Lab process status"
                            onChange={(e) =>
                                setLabProcessStatus(
                                    e.target.value as LabProcessStatus
                                )
                            }
                            required
                            displayEmpty
                            value={labProcessStatus}
                        >
                            {Object.values(LabProcessStatus).map((status) => (
                                <MenuItem key={status} value={status}>
                                    {status}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit">Submit</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default UpdateLabProcessStatusForm;
